// SidebarLink.jsx
import { Box, Button, HStack, Text } from "@chakra-ui/react";
import { NavLink } from "react-router-dom";

const SidebarLink = ({ icon: Icon, isImage = false, img, label, to, badge = 0, onClick }) => {
    return (
        <NavLink to={to} end>
            {({ isActive }) => (
                <Button
                    onClick={onClick}
                    justifyContent="start"
                    width="full"
                    variant={isActive ? "solid" : "ghost"}
                    colorScheme={isActive ? "teal" : "white"}
                    fontSize={14}
                    h="10"
                    px="3"
                    borderRadius="xl"
                    _hover={{ bg: "gray.700" }}
                >
                    <HStack w="full" spacing="3">
                        <Box w="24px" minW="24px" display="flex" alignItems="center" justifyContent="center">
                            {isImage ? (
                                <img
                                    src={img}
                                    alt={label}
                                    style={{ width: 22, height: 22, objectFit: "contain", display: "block" }}
                                />
                            ) : (
                                Icon && <Icon />
                            )}
                        </Box>

                        <Text flex="1" textAlign="left" noOfLines={1}>
                            {label}
                        </Text>

                        {badge > 0 && (
                            <Box
                                bg="red.500"
                                color="white"
                                fontSize="xs"
                                fontWeight="bold"
                                borderRadius="full"
                                minW="18px"
                                h="18px"
                                px="2"
                                display="flex"
                                alignItems="center"
                                justifyContent="center"
                            >
                                {badge}
                            </Box>
                        )}
                    </HStack>
                </Button>
            )}
        </NavLink>
    );
};

export default SidebarLink;

// import { Box, Button } from '@chakra-ui/react';
// import { Link, useLocation } from 'react-router-dom';

// const SidebarLink = ({ icon: Icon, isImage = false, img, label, to, badge, onClick }) => {
//     const location = useLocation();
//     const isActive = location.pathname.endsWith(to);

//     return (
//         <Link to={to}>
//             <Button
//                 onClick={onClick}
//                 leftIcon={!isImage ? <Icon /> : ''}
//                 justifyContent="start"
//                 width="full"
//                 variant={isActive ? 'solid' : 'ghost'}
//                 colorScheme={isActive ? 'teal' : 'white'}
//                 fontSize={14}
//                 _hover={{ bg: 'gray.700' }}
//             >
//                 {isImage &&
//                     <img
//                         src={img}
//                         alt="DLS"
//                         style={{ width: 24, height: 24, objectFit: "contain", display: "block", marginRight: 5 }}
//                     />
//                 }
//                 {label}
//                 {badge > 0 && (
//                     <Box
//                         position="absolute"
//                         top="1"
//                         right="3"
//                         bg="red.500"
//                         color="white"
//                         fontSize="xs"
//                         fontWeight="bold"
//                         borderRadius="full"
//                         w="18px"
//                         h="18px"
//                         display="flex"
//                         alignItems="center"
//                         justifyContent="center"
//                     >
//                         {badge}
//                     </Box>
//                 )}
//             </Button>
//         </Link>
//     );
// };

// export default SidebarLink;
